import { useState, useEffect, useCallback } from "react";
import { aiDigitalData } from "@/mocks/aiDigitalData";

export default function StickyNavSection() {
  const [activeAnchor, setActiveAnchor] = useState<string | null>(null);
  const [isSticky, setIsSticky] = useState(false);

  const handleScroll = useCallback(() => {
    const navEl = document.getElementById("ai-digital-page-nav");
    if (!navEl) return;
    const navTop = navEl.getBoundingClientRect().top;
    setIsSticky(navTop <= 0);

    const sections = aiDigitalData.navItems.map((item) =>
      document.querySelector(item.anchor)
    );
    let current: string | null = null;
    for (let i = sections.length - 1; i >= 0; i--) {
      const el = sections[i];
      if (el) {
        const rect = el.getBoundingClientRect();
        if (rect.top <= 120) {
          current = aiDigitalData.navItems[i].anchor;
          break;
        }
      }
    }
    setActiveAnchor(current);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  const scrollTo = (anchor: string) => {
    const el = document.querySelector(anchor);
    if (el) {
      const offset = 100;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <>
      <div
        id="ai-digital-page-nav"
        className="bg-background-50 border-b border-background-200/70"
      >
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          {/* Desktop: Horizontal nav */}
          <div className="hidden md:flex items-center gap-1 py-3 overflow-x-auto">
            {aiDigitalData.navItems.map((item) => (
              <button
                key={item.anchor}
                onClick={() => scrollTo(item.anchor)}
                className={`px-3.5 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  activeAnchor === item.anchor
                    ? "text-primary-600 bg-primary-50"
                    : "text-foreground-600 hover:text-foreground-900 hover:bg-background-100"
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>

          {/* Mobile: Horizontal scroll */}
          <div className="md:hidden flex gap-1 py-2.5 overflow-x-auto">
            {aiDigitalData.navItems.map((item) => (
              <button
                key={item.anchor}
                onClick={() => scrollTo(item.anchor)}
                className={`flex-shrink-0 px-3 py-1.5 rounded-full text-xs font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  activeAnchor === item.anchor
                    ? "text-primary-600 bg-primary-50 border border-primary-200/60"
                    : "text-foreground-600 bg-background-50 border border-background-200/50"
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {isSticky && (
        <div className="hidden md:block fixed top-0 left-0 right-0 z-40 bg-background-50/95 backdrop-blur-md border-b border-background-200/70 shadow-sm">
          <div className="max-w-[1200px] mx-auto px-4 md:px-8">
            <div className="flex items-center gap-1 py-2.5 overflow-x-auto">
              {aiDigitalData.navItems.map((item) => (
                <button
                  key={item.anchor}
                  onClick={() => scrollTo(item.anchor)}
                  className={`px-3.5 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    activeAnchor === item.anchor
                      ? "text-primary-600 bg-primary-50"
                      : "text-foreground-600 hover:text-foreground-900 hover:bg-background-100"
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}